import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AppShell from '../shell/AppShell';
import { clientMayOpen, isAppPath, isTalentOnly, talentMayOpen } from '../shell/nav';
import { useAppConfig } from '../lib/appConfig';

// Logged-in routes render inside the HD-4 shell (src/shell): the src/ui Sidebar for staff and external
// clients, the Portal Top bar for talent. Page bodies are unchanged until their own order.
// SEC-1: a talent-only account opening a staff route by URL goes to /talent before the page mounts, so it makes no call
// (the API refuses them there anyway). SEC-2: a client account on a staff-only route goes to Home the same way.
// HD-11.1: a path the app does not have skips both bounces and renders "Page not found" (App.jsx's catch-all) in the frame.
export default function PrivateRoute() {
  const { user, loading } = useAuth();
  const { pathname } = useLocation();
  const { aiProductionEnabled } = useAppConfig();
  if (loading) return <div className="app-loading">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.mustChangePassword) return <Navigate to="/change-password" replace />;
  const known = isAppPath(pathname, { aiEnabled: aiProductionEnabled });
  if (known && isTalentOnly(user) && !talentMayOpen(pathname)) return <Navigate to="/talent" replace />;
  if (known && user.isExternal && !clientMayOpen(pathname)) return <Navigate to="/dashboard" replace />;   // SEC-2
  return <AppShell />;
}
